import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import {ColorPicker, ColorPickerValueType} from "primereact/colorpicker";
import {Divider} from "primereact/divider";
import React, {useEffect, useState} from "react";

interface DateTimeRangeColorSelectorProps {
    setDatesRange: (value: any) => void;
    setSelectedColor: (value: ColorPickerValueType) => void,
    selectedColor: ColorPickerValueType
}

const DateTimeRangeColorSelector = ({setDatesRange, setSelectedColor, selectedColor}: DateTimeRangeColorSelectorProps) => {

    const [dateFrom, setDateFrom] = useState<Date>(new Date);
    const [dateTo, setDateTo] = useState<Date>(new Date());


    const handleOnSelectDateFrom = (e: any) => {
        setDateFrom(e);
        setDatesRange((prevState: Date[]) => {
            const oldDateRange = [...prevState];
            oldDateRange[0] = e;
            return oldDateRange;
        });
    };

    const handleOnSelectDateTo = (e: any) => {
        setDateTo(e);
        setDatesRange((prevState: Date[]) => {
            const oldDateRange = [...prevState];
            oldDateRange[1] = e;
            return oldDateRange;
        });
    };

    useEffect(() => {
        setDatesRange([dateFrom, dateTo]);
    }, []);

    return (
        <div className="1 flex flex-column">
            <Divider/>
            <p>Select specific range to color:</p>
            <div className="flex gap-2 align-items-center">
                <div className=" flex flex-column justify-content-center align-text-center calendarItem">
                    <label> From:</label>
                    <CalendarWrapper id="datetimeFrom"
                                     value={dateFrom}
                                     onChange={(e) => handleOnSelectDateFrom(e)}
                    />
                </div>
                <div className="flex flex-column justify-content-center align-text-center calendarItem">
                    <label> To:</label>
                    <CalendarWrapper value={dateTo}
                                     onChange={(e) => handleOnSelectDateTo(e)}
                    />
                </div>
                <div className="flex flex-column justify-content-center align-text-center">
                    <label> Color:</label>
                    <ColorPicker value={selectedColor} onChange={e => setSelectedColor(e.value)} />
                </div>
            </div>
        </div>
    );
};

export default DateTimeRangeColorSelector;